import { kUndoQueueMax } from "../constants";
import { QXMLObject } from "./QXMLObject";
import { Globals } from "./Globals";

export class QDoc extends QXMLObject {
  constructor() {
    // Undo/Redo handling
    super();
    this.fUndoBuffer = null;
    this.fRedoBuffer = null;
    this.fUndoInitialized = false;
  }

  ApplyCheckPoint(checkPoint) {
    return null;
    // Override this
  }

  GetCheckPoint() {
    return null;
    // Override this
  }

  UndoAll() {
    if (this.fUndoBuffer == null) return;
    var undoCheckPoint = this.fUndoBuffer[0];
    if (undoCheckPoint == null) return;
    var updateCode = this.ApplyCheckPoint(undoCheckPoint);
    this.ClearJournal();
    this.ClearUndoRedoBuffers();
    this.SetDirty(true);
    return updateCode;
  }

  UndoLast() {
    //  console.log("UndoLast");

    var undoCheckPoint = this.fUndoBuffer.pop();

    // Applying will create a new Journal when the old Journal is restored
    var updateCode = this.ApplyCheckPoint(undoCheckPoint);

    var redoCheckPoint = this.GetCheckPoint();
    this.ClearJournal();
    this.fRedoBuffer.push(redoCheckPoint);
    this.SetDirty(true);
    return updateCode;
    //  console.log("--Undo Buffer Len:", this.fUndoBuffer.length);
    //  console.log("--Redo Buffer Len:", this.fRedoBuffer.length);
  }

  RedoLast() {
    //  console.log("RedoLast");

    var redoCheckPoint = this.fRedoBuffer.pop();
    // Applying will create a new Journal when the old Journal is restored
    var updateCode = this.ApplyCheckPoint(redoCheckPoint);
    var undoCheckPoint = this.GetCheckPoint();
    this.ClearJournal();
    this.fUndoBuffer.push(undoCheckPoint);
    this.SetDirty(true);
    return updateCode;
    // console.log("--Undo Buffer Len:", this.fUndoBuffer.length);
    // console.log("--Redo Buffer Len:", this.fRedoBuffer.length);
  }

  StartJournal() {
    // Override
  }

  ClearJournal() {
    // Override
  } //20
  StartCheckPoint() {
    //console.log("StartCheckPoint");
    if (!this.fUndoInitialized) {
      //  console.log("--InitUndo--");
      this.fUndoInitialized = true;
      this.fUndoBuffer = [];
      this.fRedoBuffer = [];
    }

    this.StartJournal();
  }

  EndCheckPoint() {
    //console.log("EndCheckPoint");
    var cp = this.GetCheckPoint(); // Get prior state
    if (cp) {
      this.fRedoBuffer = [];
      //  console.log("Adding CP to UndoBuffer");
      this.fUndoBuffer.push(cp); // Put prior state on undo stack
      var qLen = this.fUndoBuffer.length;
      if (qLen > kUndoQueueMax) this.fUndoBuffer.shift();
    }
    // else
    //    console.log("CheckPoint contains no changes");

    this.ClearJournal();
    this.UpdateDocContext();
  }

  ClearUndoRedoBuffers() {
    this.fUndoInitialized = false;
    this.ClearUndoBuffer();
    this.ClearRedoBuffer();
    this.UpdateDocContext();
  }

  ClearUndoBuffer() {
    this.fUndoBuffer = null;
  }

  ClearRedoBuffer() {
    this.fRedoBuffer = null;
  }

  UndoBufferLength() {
    if (this.fUndoBuffer) return this.fUndoBuffer.length;
    return 0;
  }

  RedoBufferLength() {
    if (this.fRedoBuffer) return this.fRedoBuffer.length;
    return 0;
  }

  DoEvaluateVariable(variableName) {
    return variableName;
  }

  IsVariable(variableName) {
    var l = variableName.length;
    if (l < 3) return false;

    if (variableName[0] == "[" && variableName[l - 1] == "]") return true;

    return false;
  }

  IsDateVariable(variableName) {
    return false;
  }

  EvaluateVariable(variableName) {
    var isVariable = this.IsVariable(variableName);
    if (isVariable) {
      var l = variableName.length;
      var v = variableName.substring(1, l - 1);
      return this.DoEvaluateVariable(v);
    }

    return variableName;
  }

  UpdateDocContext() {
    if (Globals._wsMgr.fDocContextProviderFn) Globals._wsMgr.fDocContextProviderFn({ state: this });
  }
}
